import { render, staticRenderFns } from "./price-live-cattle.vue?vue&type=template&id=39678f24&scoped=true&"
import script from "./price-live-cattle.vue?vue&type=script&lang=js&"
export * from "./price-live-cattle.vue?vue&type=script&lang=js&"
import style0 from "./price-live-cattle.vue?vue&type=style&index=0&id=39678f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39678f24",
  null
  
)

export default component.exports